import { Spinner } from "react-bootstrap";

export function SkeletonLine({ className = "", width = "100%", height = 14 }) {
  return (
    <span
      className={`skeleton-line custom-shimmer ${className}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

export function InlineLoader() {
  return (
    <Spinner
      as="span"
      animation="border"
      size="sm"
      role="status"
      aria-hidden="true"
    />
  );
}

export function TableSkeletonRows({ rows = 5, columns = 4 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr className="table-skeleton-row" key={`skeleton-row-${rowIndex}`}>
          {Array.from({ length: columns }).map((__, columnIndex) => (
            <td key={`skeleton-cell-${rowIndex}-${columnIndex}`}>
              <SkeletonLine
                width={columnIndex === columns - 1 ? "64%" : "86%"}
                height={columnIndex === 0 ? 16 : 13}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export function FormSkeleton({ rows = 6 }) {
  return (
    <div className="form-skeleton" aria-hidden="true">
      {Array.from({ length: rows }).map((_, index) => (
        <div className="form-skeleton-field" key={`form-skeleton-${index}`}>
          <SkeletonLine width="28%" height={12} />
          <SkeletonLine height={index > 2 ? 82 : 42} />
        </div>
      ))}
    </div>
  );
}

export function CardMetricSkeleton() {
  return <SkeletonLine className="metric-shimmer" width={72} height={44} />;
}

export function PageSkeleton() {
  return (
    <div className="page-skeleton" aria-hidden="true">
      <SkeletonLine width="32%" height={28} />
      <SkeletonLine width="46%" height={14} />
      <div className="page-skeleton-grid">
        <SkeletonLine height={96} />
        <SkeletonLine height={96} />
        <SkeletonLine height={96} />
      </div>
    </div>
  );
}
